export default __webpack_public_path__ + "static/media/control-skin-bird.7a274740.png";